<template>
  <a-layout class="layout-body">
    <a-layout-content class="layout-content">
      <router-view />
    </a-layout-content>
  </a-layout>
</template>

<script>
import RouteView from './RouteView'

export default {
    name: 'basicLayout',
    data() {
      return {
        RouteView,
      }
    },
    created () {
    },
    computed: {
      
    },
    methods: {
      
    }
}
</script>

<style lang="less" scoped>

</style>